import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import NavBar from "./components/nav/NavBar";
import Drawer from "./components/nav/Drawer";
import Footer from "./components/nav/Footer";
import utils from "./utils";
import { Toaster } from "react-hot-toast";
import ServicesPage from "./pages/ServicesPage";
import BlogPage from "./pages/BlogPage";
import PageNotFound from "./pages/PageNotFound";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/auth/LoginPage";
import AdminPage from "./pages/auth/AdminPage";
import { useEffect, useState } from "react";
import PostViewPage from "./pages/PostViewPage";
import AIChat from "./components/chat/AiChat";
import MaintenancePage from "./pages/MaintenancePage";
import blogServices from "./services/BlogServices";

function App() {
  const location = useLocation();
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  // Fetch maintenance status on app load
  useEffect(() => {
    blogServices
      .getMaintenanceStatus()
      .then((res) => {
        setMaintenanceMode(res.data.is_on_maintenance);
        setLoading(false);
      })
      .catch(() => {
        setMaintenanceMode(false);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const topNav = document.getElementById("nav-top");
    setTimeout(() => {
      if (topNav) topNav.scrollIntoView({ behavior: "smooth" });
    }, 45);
  }, [location]);

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-900 flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-2 border-[#FFC000] border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (
    maintenanceMode &&
    !location.pathname.startsWith("/mnt") &&
    !location.pathname.startsWith("/auth")
  ) {
    return <MaintenancePage />;
  }

  return (
    <div className="App">
      <div className="drawer">
        <input id="nav-drawer" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content">
          <div id="nav-top" className=""></div>
          <NavBar />
          <div className="page">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/auth/login" element={<LoginPage />} />
              <Route path="/auth/admin" element={<AdminPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/post/:slug" element={<PostViewPage />} />
              <Route path="/mnt" element={<MaintenancePage />} />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </div>
          <AIChat />
          <Footer />
          <Toaster
            position={utils.toasterPoisition}
            toastOptions={utils.toasterOptions}
          />
        </div>
        <Drawer />
      </div>
    </div>
  );
}

export default App;
